/* Slider layout for the products-with-image section.
	 Turns the product column into an infinite Swiper carousel and rotates the
	 brand panel images one step on every slide change. */
;(function () {
	const toBoolean = (value) => value === 'true'
	const prefersReducedMotion = () =>
		window.matchMedia &&
		window.matchMedia('(prefers-reduced-motion: reduce)').matches

	/* Advances the brand panel one image per slide change, wrapping forever.
		 The image count is independent of the product count on purpose: merchants
		 add as many or as few brand images as they like. */
	const createRotator = (root) => {
		const panel = root.querySelector('.pwi_image-rotator')
		if (!panel) return null

		const images = Array.from(panel.querySelectorAll('.pwi_image-item'))
		if (images.length < 2) return null

		let current = 0
		const show = (index) => {
			images.forEach((image, i) => image.classList.toggle('show', i === index))
		}
		show(0)

		return {
			next() {
				current = (current + 1) % images.length
				show(current)
			},
		}
	}

	const buildParams = (block, slideCount) => {
		const perRow = Number(block.dataset.perRow) || 3
		const mobile = Number(block.dataset.mobile) || 2
		const speed = (Number(block.dataset.speed) || 0.8) * 1000
		const delay = (Number(block.dataset.delay) || 3) * 1000
		const autoplay = toBoolean(block.dataset.autoplay) && !prefersReducedMotion()
		const stopAutoplay = toBoolean(block.dataset.stopAutoplay)
		const showArrows = toBoolean(block.dataset.showArrows)
		const showPagination = toBoolean(block.dataset.showPagination)

		/* Looping needs more slides than are on screen, otherwise Swiper renders
			 blank gaps where the duplicated slides should be. */
		const canLoop = slideCount > perRow

		const params = {
			speed: speed,
			keyboard: true,
			watchOverflow: true,
			loop: canLoop,
			slidesPerView: mobile,
			slidesPerGroup: 1,
			spaceBetween: 12,
			breakpoints: {
				576: {
					slidesPerView: perRow,
					spaceBetween: 16,
				},
				990: {
					slidesPerView: perRow,
					spaceBetween: 16,
				},
			},
		}

		if (autoplay && canLoop) {
			params.autoplay = {
				delay: delay,
				pauseOnMouseEnter: stopAutoplay,
				disableOnInteraction: false,
			}
		}

		if (showArrows) {
			const root = block.closest('.products-with-image')
			const nextEl = root && root.querySelector('.section-header__button-arrow .swiper-button-next')
			const prevEl = root && root.querySelector('.section-header__button-arrow .swiper-button-prev')
			if (nextEl && prevEl) {
				params.navigation = { nextEl: nextEl, prevEl: prevEl }
			}
		}

		if (showPagination) {
			const paginationEl = block.querySelector('.pwi_slider-pagination')
			if (paginationEl) {
				params.pagination = {
					el: paginationEl,
					clickable: true,
					dynamicBullets: slideCount > 8,
				}
			}
		}

		return params
	}

	const initBlock = (block) => {
		const el = block.querySelector('.pwi_swiper')
		if (!el || typeof Swiper === 'undefined') return

		/* Swiper attaches to the inner element, so a stale instance has to be
			 destroyed here or its autoplay timer keeps running after a theme
			 editor reload. */
		if (el.swiper) {
			try {
				el.swiper.destroy(true, true)
			} catch (e) {}
		}

		const slideCount = el.querySelectorAll('.swiper-slide').length
		if (!slideCount) return

		const root = block.closest('.products-with-image')
		const rotator = root ? createRotator(root) : null

		const params = buildParams(block, slideCount)
		if (rotator) {
			params.on = Object.assign({}, params.on, {
				slideChange: () => rotator.next(),
			})
		}

		try {
			new Swiper(el, params)
		} catch (e) {}
	}

	const init = (scope) => {
		const container = scope && scope.querySelectorAll ? scope : document
		container.querySelectorAll('[data-pwi-slider]').forEach(initBlock)
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', () => init(document))
	} else {
		init(document)
	}

	document.addEventListener('shopify:section:load', (event) => init(event.target))
	document.addEventListener('shopify:section:unload', (event) => {
		event.target.querySelectorAll('.pwi_swiper').forEach((el) => {
			if (el.swiper) {
				try {
					el.swiper.destroy(true, true)
				} catch (e) {}
			}
		})
	})
})()
